export enum TransactionNamespaces {
  BALANCE = 'balance',
  GAME = 'game',
  BONUS = 'bonus',
  INVENTORY = 'inventory',
  LEGACY = 'legacy',
}
